import React from "react";

const Footer = () => {
  return (
    <div className="app__counter-container" style={{ marginTop: "100px" }}>
      <h5> Mozes Walker 2022</h5>
    </div>
  );
};

export default Footer;
